import { Address, isCryptoPunk } from 'nftx.js';
import ApproveItem from './ApproveItem';

/**
 * Because some vaults (punks) need to be approved individually
 * We either want a single approve item, or multiple
 * In order to correctly tally up the total number of actions
 * We have to insert them as an array instead of rendering a wrapper component
 */
const renderApproveActionItems = ({
  index,
  spenderAddress,
  standard,
  symbol,
  tokenAddress,
  tokenIds,
}: {
  index: number;
  symbol: string;
  spenderAddress: Address;
  tokenAddress: Address;
  standard: 'ERC721' | 'ERC1155';
  tokenIds: `${number}`[];
}) => {
  if (isCryptoPunk(tokenAddress)) {
    return tokenIds.map((tokenId, i) => {
      return (
        <ApproveItem
          key={index}
          index={index + i}
          type="on-chain"
          spenderAddress={spenderAddress}
          standard={standard}
          symbol={`${symbol} #${tokenId}`}
          tokenAddress={tokenAddress}
          tokenIds={[tokenId]}
        />
      );
    });
  }

  return [
    <ApproveItem
      key={index}
      index={index}
      type="on-chain"
      spenderAddress={spenderAddress}
      standard={standard}
      symbol={symbol}
      tokenAddress={tokenAddress}
      tokenIds={tokenIds}
    />,
  ];
};

export default renderApproveActionItems;
